export var HubSpotFormTemplateAvailabilityKeys;
(function (HubSpotFormTemplateAvailabilityKeys) {
    HubSpotFormTemplateAvailabilityKeys["AI_GENERATED"] = "ai-generated";
    HubSpotFormTemplateAvailabilityKeys["BLANK"] = "blank";
    HubSpotFormTemplateAvailabilityKeys["NEWSLETTER"] = "newsletter";
    HubSpotFormTemplateAvailabilityKeys["CONTACT_US"] = "contact-us";
    HubSpotFormTemplateAvailabilityKeys["EVENT_REGISTRATION"] = "event-registration";
    HubSpotFormTemplateAvailabilityKeys["TALK_TO_AN_EXPERT"] = "talk-to-an-expert";
    HubSpotFormTemplateAvailabilityKeys["BOOK_A_MEETING"] = "book-a-meeting";
    HubSpotFormTemplateAvailabilityKeys["GATED_CONTENT"] = "gated-content";
    HubSpotFormTemplateAvailabilityKeys["SUPPORT"] = "support";
})(HubSpotFormTemplateAvailabilityKeys || (HubSpotFormTemplateAvailabilityKeys = {}));
export var ExcludedTemplateAvailabilityKeys;
(function (ExcludedTemplateAvailabilityKeys) {
    ExcludedTemplateAvailabilityKeys["SUPPORT"] = "support";
    ExcludedTemplateAvailabilityKeys["AI_GENERATED"] = "ai-generated";
})(ExcludedTemplateAvailabilityKeys || (ExcludedTemplateAvailabilityKeys = {}));
export const TemplateLabels = {
    [HubSpotFormTemplateAvailabilityKeys.BLANK]: 'Blank Form',
    [HubSpotFormTemplateAvailabilityKeys.NEWSLETTER]: 'Newsletter Form',
    [HubSpotFormTemplateAvailabilityKeys.CONTACT_US]: 'Contact Us Form',
    [HubSpotFormTemplateAvailabilityKeys.EVENT_REGISTRATION]: 'Event Registration Form',
    [HubSpotFormTemplateAvailabilityKeys.TALK_TO_AN_EXPERT]: 'Talk to an Expert Form',
    [HubSpotFormTemplateAvailabilityKeys.BOOK_A_MEETING]: 'Book a Meeting Form',
    [HubSpotFormTemplateAvailabilityKeys.GATED_CONTENT]: 'Gated Content Form',
};
export const TemplateValues = {
    [HubSpotFormTemplateAvailabilityKeys.BLANK]: 'BLANK',
    [HubSpotFormTemplateAvailabilityKeys.NEWSLETTER]: 'NEWSLETTER',
    [HubSpotFormTemplateAvailabilityKeys.CONTACT_US]: 'CONTACT_US',
    [HubSpotFormTemplateAvailabilityKeys.EVENT_REGISTRATION]: 'EVENT_REGISTRATION',
    [HubSpotFormTemplateAvailabilityKeys.TALK_TO_AN_EXPERT]: 'TALK_TO_AN_EXPERT',
    [HubSpotFormTemplateAvailabilityKeys.BOOK_A_MEETING]: 'BOOK_A_MEETING',
    [HubSpotFormTemplateAvailabilityKeys.GATED_CONTENT]: 'GATED_CONTENT',
};
